<section class="py-5" style="background: linear-gradient(115deg, #f8fbff 70%, #e8eef8 100%);">
    <div class="container">
        <div class="row justify-content-center mb-4">
            <div class="col-lg-8 text-center">
                <h2 class="fw-bold mb-2" style="font-size:2.1rem;">
                    <span class="text-primary">Für wen</span> ist unsere Plattform die <span class="text-success">richtige Lösung?</span>
                </h2>
                <p class="lead text-secondary mb-0" style="font-size:1.18rem;">
                    Unsere Plattform ist vielseitig einsetzbar – profitieren Sie von optimal zugeschnittenen Firmenlisten, egal ob für Vertrieb, Marketing, Recruiting oder Business Development.
                </p>
            </div>
        </div>
        <div class="row g-4 justify-content-center">
            <div class="col-md-6 col-lg-3">
                <div class="target-card h-100 border-0 shadow-sm rounded-4 text-center p-4 bg-white position-relative">
          <span class="icon-bg icon-gradient-blue mb-3 d-inline-flex align-items-center justify-content-center rounded-circle shadow-sm">
            <i class="fa fa-users fa-2x"></i>
          </span>
                    <h5 class="fw-semibold mb-2">Vertriebsteams</h5>
                    <p class="mb-0 text-secondary small">
                        Generieren Sie neue Leads <br> effizienter & gezielter.
                    </p>
                </div>
            </div>
            <div class="col-md-6 col-lg-3">
                <div class="target-card h-100 border-0 shadow-sm rounded-4 text-center p-4 bg-white position-relative">
          <span class="icon-bg icon-gradient-green mb-3 d-inline-flex align-items-center justify-content-center rounded-circle shadow-sm">
            <i class="fa fa-bullhorn fa-2x"></i>
          </span>
                    <h5 class="fw-semibold mb-2">Marketing-Agenturen</h5>
                    <p class="mb-0 text-secondary small">
                        Steuern Sie Kampagnen <br> punktgenau & datengestützt.
                    </p>
                </div>
            </div>
            <div class="col-md-6 col-lg-3">
                <div class="target-card h-100 border-0 shadow-sm rounded-4 text-center p-4 bg-white position-relative">
          <span class="icon-bg icon-gradient-yellow mb-3 d-inline-flex align-items-center justify-content-center rounded-circle shadow-sm">
            <i class="fa fa-briefcase fa-2x"></i>
          </span>
                    <h5 class="fw-semibold mb-2">Recruiter</h5>
                    <p class="mb-0 text-secondary small">
                        Finden Sie neue Ansprechpartner <br> und relevante Job-Links.
                    </p>
                </div>
            </div>
            <div class="col-md-6 col-lg-3">
                <div class="target-card h-100 border-0 shadow-sm rounded-4 text-center p-4 bg-white position-relative">
          <span class="icon-bg icon-gradient-purple mb-3 d-inline-flex align-items-center justify-content-center rounded-circle shadow-sm">
            <i class="fa fa-rocket fa-2x"></i>
          </span>
                    <h5 class="fw-semibold mb-2">Start-ups & KMU</h5>
                    <p class="mb-0 text-secondary small">
                        Erschließen Sie neue Märkte <br> und Geschäftschancen.
                    </p>
                </div>
            </div>
        </div>
    </div>
</section>